import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import Box from '../../Box/Box.js';
import { eventPreventDefault } from '../../utils/events/index.js';

// Prevent input blur when interacting with the "no options" content
var renderNoOptions = function renderNoOptions(_ref) {
  var classes = _ref.classes,
    noOptionsText = _ref.noOptionsText;
  return /*#__PURE__*/React__default.createElement(Box, {
    className: classes == null ? void 0 : classes.noOptions,
    role: "presentation",
    onMouseDown: eventPreventDefault
  }, noOptionsText);
};
var renderGroupedOptions = function renderGroupedOptions(params) {
  var classes = params.classes,
    getOptionProps = params.getOptionProps,
    groupBy = params.groupBy,
    groupedOptions = params.groupedOptions,
    inputValue = params.inputValue,
    _params$renderGroup = params.renderGroup,
    renderGroup = _params$renderGroup === void 0 ? function (group) {
      return /*#__PURE__*/React__default.createElement("li", {
        key: group.key
      }, /*#__PURE__*/React__default.createElement(Box, {
        className: classes == null ? void 0 : classes.groupLabel
      }, group.group), /*#__PURE__*/React__default.createElement("ul", {
        className: classes == null ? void 0 : classes.groupUl
      }, group.children));
    } : _params$renderGroup,
    renderOption = params.renderOption;
  var renderListOption = function renderListOption(option, index) {
    var optionProps = getOptionProps({
      index: index,
      option: option
    });
    return /*#__PURE__*/React__default.createElement("li", _extends({
      className: classes == null ? void 0 : classes.option
    }, optionProps, {
      key: optionProps.id
    }), renderOption(option, {
      index: index,
      inputValue: inputValue,
      selected: Boolean(optionProps['aria-selected'])
    }));
  };
  // @ts-ignore
  return groupedOptions.map(function (option, index) {
    if (groupBy) {
      var group = option.group,
        groupIndex = option.index,
        key = option.key,
        options = option.options;
      return renderGroup({
        children: options.map(function (groupOption, groupOptionIndex) {
          return renderListOption(groupOption, groupIndex + groupOptionIndex);
        }),
        group: group,
        key: key.toString()
      });
    }
    return renderListOption(option, index);
  });
};

export { renderGroupedOptions, renderNoOptions };
//# sourceMappingURL=renderers.js.map
